import React from 'react';
import Icon from 'components/lib/icons/icon';

/**
 * @visibleName Reporting Fill
 */

export default function ReportingFillIcon(props) {
  return (
    <Icon viewBox="0 0 16 16" {...props}>
      <path
        clipRule="evenodd"
        d="M0.5 0C0.223858 0 6.47358e-09 0.223858 6.47358e-09 0.5V15.4999C-8.09107e-09 15.4999 6.47176e-09 15.5 6.47358e-09 15.5C6.47358e-09 15.7761 0.223858 16 0.5 16H15.5C15.7761 16 16 15.7761 16 15.5C16 15.2239 15.7761 15 15.5 15L1 15V0.5C1 0.223858 0.776142 0 0.5 0ZM4 8C3.44772 8 3 8.44772 3 9V13C3 13.5523 3.44772 14 4 14C4.55228 14 5 13.5523 5 13V9C5 8.44772 4.55228 8 4 8ZM9 9C9 8.44772 9.44771 8 10 8C10.5523 8 11 8.44772 11 9V13C11 13.5523 10.5523 14 10 14C9.44771 14 9 13.5523 9 13V9ZM7 4C6.44772 4 6 4.44772 6 5V13C6 13.5523 6.44772 14 7 14C7.55228 14 8 13.5523 8 13V5C8 4.44772 7.55228 4 7 4ZM12 5C12 4.44772 12.4477 4 13 4C13.5523 4 14 4.44772 14 5V13C14 13.5523 13.5523 14 13 14C12.4477 14 12 13.5523 12 13V5Z"
        fillRule="evenodd"
      />
    </Icon>
  );
}
